import { render, staticRenderFns } from "./AssignUserHours.vue?vue&type=template&id=58160c0a&"
import script from "./AssignUserHours.vue?vue&type=script&lang=js&"
export * from "./AssignUserHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports